(ns ballot-scout-v2-frontend.components.pagination
  (:require [ballot-scout-v2-frontend.util :as util]
            [reagent.core :as r]))

(defn page-input-form [{:keys [curr-page on-page]}]
  (r/with-let [input-val (r/atom nil)
               submit-new-page!
               (fn [e]
                 (.preventDefault e)
                 (when @input-val
                   (on-page @input-val)
                   (reset! input-val nil)))]
    [:form {:on-submit submit-new-page!}
     [:div {:class "field has-addons is-small pagination-child"}
      [:div {:class "control is-small"}
       [:button {:class "button is-small"} "Page"]]
      [:div {:class "control is-small"}
       [:input {:type "number"
                :aria-label "Navigate to page number"
                :value (or @input-val curr-page)
                :class "input is-small"
                :on-change #(reset! input-val (-> % .-target .-value))
                :on-blur submit-new-page!}]]]]))

(defn pagination [{:keys [curr-page total-pages on-page] :as props}]
  (let [curr-page (util/->int curr-page)
        prev-page (dec curr-page)
        next-page (inc curr-page)
        cls "pagination-link button is-small"
        show-prev? (pos? prev-page)
        show-next? (and total-pages (<= next-page total-pages))
        pagination-li-a
        (fn [p current?]
          [:li {:key (str "pagination-btn-" p)}
           [:a {:class (str cls (if current? " is-current" ""))
                :on-click #(on-page p)}
            p]])]
    [:span {:class "columns pagination-container pb-3"}
     [:div {:class "column is-one-third is-hidden-mobile py-1"}
      [:nav {:class "pagination"}
       [:ul {:class "pagination-list"}
        (when (> curr-page 2)
          [:<>
           [pagination-li-a 1]
           [:li [:span {:class "pagination-ellipsis"} "…"]]])

        (when show-prev?
          [pagination-li-a prev-page])

        [pagination-li-a curr-page true]

        (when show-next?
          [pagination-li-a next-page])

        (when (and total-pages (<= 2 (- total-pages curr-page)))
          [:<>
           [:li [:span {:class "pagination-ellipsis"} "…"]]
           [pagination-li-a total-pages]])]]]

     [:div {:class "column is-two-thirds py-1"}
      [:div.is-pulled-right [page-input-form props]]
      [:div.is-pulled-right
       [:a {:class "pagination-previous button is-small"
            :on-click #(when show-prev? (on-page prev-page))
            :disabled (not show-prev?)}
        "Previous"]
       [:a {:class "pagination-next button is-small"
            :on-click #(when show-next? (on-page next-page))
            :disabled (not show-next?)}
        "Next"]]]]))
